import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { dacScenariosInitialState, DacScenariosStateProps, dacScenariosStateStore } from './dac-scenarios-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class DacScenariosRepository extends BaseStoreRepository<DacScenariosStateProps> {
  constructor() {
    super(dacScenariosStateStore.pipe(select(state => state)), dacScenariosStateStore, dacScenariosInitialState);
  }
}
